<template>
  <div class="page-wrapper py-4">
    <div id="master" ref="master" class="master" @scroll="handleScroll">
      <menutop :menu/>
      <FacturacionNew id="page1" bg="white" class="section" />
      <TicketInteligenteNew id="page2" bg="black" class="section" />
      <AutoFacturacionNew id="page3" bg="white" class="section" />
      <MicrositioNew id="page4" bg="white" class="section" />
      <FacturasGlobalesNew id="page5" bg="white" class="section" />
      <TicketPerdidoNew id="page6" bg="white" class="section" />
      <TituloProcesosNew id="page7" bg="black" class="section" />
      <DescuentosNew id="page8" bg="white" class="section" />
      <BackofficeNew id="page9" bg="white" class="section" />
      <TestimonioIntelNew id="page10" bg="white" class="section" />
      <CallToActionIntelNew id="page11" bg="white" class="section" />
      <FooterIntelNew id="page12" bg="black" class="section" />
      
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import menutop from '@/components/structure/menutop.vue'
import FacturacionNew from '@/components/pages/intel/FacturacionNew.vue'
import TicketInteligenteNew from '@/components/pages/intel/TicketInteligenteNew.vue'
import AutoFacturacionNew from '@/components/pages/intel/AutoFacturacionNew.vue'
import MicrositioNew from '@/components/pages/intel/MicrositioNew.vue'
import FacturasGlobalesNew from '@/components/pages/intel/FacturasGlobalesNew.vue'
import TicketPerdidoNew from '@/components/pages/intel/TicketPerdidoNew.vue'
import TituloProcesosNew from '@/components/pages/intel/TituloProcesosNew.vue'
import DescuentosNew from '@/components/pages/intel/DescuentosNew.vue'
import BackofficeNew from '@/components/pages/intel/BackofficeNew.vue'
import TestimonioIntelNew from '@/components/pages/intel/TestimonioIntelNew.vue'
import CallToActionIntelNew from '@/components/pages/intel/CallToActionIntelNew.vue'
import FooterIntelNew from '@/components/pages/intel/FooterIntelNew.vue'

export default {
  name: 'intelView',
  props:{
      con: {
          default: {},
          type: Object
      }
  },
  components: {
    menutop,
    FacturacionNew,
    TicketInteligenteNew,
    AutoFacturacionNew,
    MicrositioNew,
    FacturasGlobalesNew,
    TicketPerdidoNew,
    TituloProcesosNew,
    DescuentosNew,
    BackofficeNew,
    TestimonioIntelNew,
    CallToActionIntelNew,
    FooterIntelNew
  },
  watch: {
    currentSection() {
      if(document.getElementById(`page${this.currentSection}`)) {
        console.log(document.getElementById(`page${this.currentSection}`).getAttribute('bg'), this.currentSection);
        this.menu = document.getElementById(`page${this.currentSection}`).getAttribute('bg');
      }
    }
  },
  data() {
    return {
      menu: 'white',
      currentSection: 1,
    };
  },
  methods: {
    handleScroll() {
      const scrollPosition = this.$refs.master.scrollTop;
      const windowHeight = window.innerHeight;
      const menuHeight = 80; // Altura del menutop
      const adjustedScrollPosition = scrollPosition + menuHeight;
      const section = Math.floor(adjustedScrollPosition  / windowHeight) + 1;
      if (section < 1) {
        this.currentSection = 1;
      } else if (section > 12) {
        this.currentSection = 12;
      } else {
        this.currentSection = section;
      }
    },
 
  },
}
</script>

<style lang="css">
/* 1) El wrapper ocupa toda la pantalla */
.page-wrapper {
  background-color: #F0EFEB; /* background color */
  width: 100%;
  height: 96vh;
  display: flex;
  justify-content: center; /* centra .master horizontalmente */
  align-items: center;     /* centra .master verticalmente */
  box-sizing: border-box;
}

.master {
  margin-top: 16px !important;
  position: relative;
  background-color: #fff;
  border-radius: 16px;
  width: 97.95vw !important;
  height: 95.5vh !important;
  max-width: none;
  overflow-x: hidden;
  overflow-y: auto;
  scroll-snap-type: y mandatory;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: flex-start;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);

  /* Firefox */
  scrollbar-width: none !important;
  /* IE 10+ */
  -ms-overflow-style: none !important;
}

/* Chrome, Safari, Opera */
.master::-webkit-scrollbar {
  display: none !important;
}


@media (max-width: 992px) {
  .master {
      padding-top: 0px !important;
  }
}
</style>